<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Dental Patients",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Dental Patients",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Dental Patients",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "patientName",
          sortable: true,
          label: "NAME",
        },
        {
          key: "patient.patientCode",
          sortable: true,
          label: "NUMBER",
        },
        {
          key: "patient.patientContact",
          sortable: true,
          label: "CONTACT",
        },
        {
          key: "patient.patientAddress",
          sortable: true,
          label: "ADDRESS",
        },
        {
          key: "weight_field",
          sortable: true,
          label: "WEIGHT",
        },
        {
          key: "temp_field",
          sortable: true,
          label: "TEMPERATURE",
        },

        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("doctor", ["DentalPatients"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.DentalPatients ? this.DentalPatients.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.DentalPatients ? this.DentalPatients.length : 1;
  },
  methods: {
    ...mapActions({
      FetchDentalPatients: "doctor/fetchDentalPatients"
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  created() {
    this.FetchDentalPatients();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
         <div class="card">
          <div class="card-body">
        
            <b-tabs pills justified content-class="p-3 text-muted">
              <b-tab active class="border-0">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Pending</span>
                </template>
                 <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="DentalPatients ? DentalPatients : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                 <template #cell(patientName)="data">
                  {{ data.item.patient.patientName }}
                   <span
                    class="badge rounded-pill bg-success"
                    v-if="data.item.pay_status == 'Cleared'"
                    >Cleared</span
                  >
                   <span
                    class="badge rounded-pill bg-primary"
                    v-else-if="data.item.pay_status == 'insured'"
                    >Insured</span
                  >
                  <span
                    class="badge rounded-pill bg-danger"
                    v-else
                  >
                   Not Cleared</span
                  >
                
                </template>
                <template #cell(temp_field)="data">
                  {{ data.item.temp ? data.item.temp + " &#x2103;" : "--" }}
                </template>
                <template #cell(weight_field)="data">
                  {{ data.item.weight ? data.item.weight + " kg" : "--" }}
                </template>
                <template #cell(actions)="data">
                  <router-link
                    :to="{
                      name: 'PatientsDetails',
                      params: { id: data.item.patient.id, visit: data.item.id, type: 6 },
                    }"
                  >
                    <button class="btn btn-primary btn-sm">Details</button>
                  </router-link>
                </template>
              </b-table>
              <center>
                <h3 v-if="!DentalPatients" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">In progress</span>
                </template>
                  <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="DentalPatients ? DentalPatients : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                 <template #cell(patientName)="data">
                  {{ data.item.patient.patientName }}
                   <span
                    class="badge rounded-pill bg-success"
                    v-if="data.item.pay_status == 'Cleared'"
                    >Cleared</span
                  >
                   <span
                    class="badge rounded-pill bg-primary"
                    v-else-if="data.item.pay_status == 'insured'"
                    >Insured</span
                  >
                  <span
                    class="badge rounded-pill bg-danger"
                    v-else
                  >
                   Not Cleared</span
                  >
                
                </template>
                <template #cell(temp_field)="data">
                  {{ data.item.temp ? data.item.temp + " &#x2103;" : "--" }}
                </template>
                <template #cell(weight_field)="data">
                  {{ data.item.weight ? data.item.weight + " kg" : "--" }}
                </template>
                <template #cell(actions)="data">
                  <router-link
                    :to="{
                      name: 'PatientsDetails',
                      params: { id: data.item.patient.id, visit: data.item.id, type: 6 },
                    }"
                  >
                    <button class="btn btn-primary btn-sm">Details</button>
                  </router-link>
                </template>
              </b-table>
              <center>
                <h3 v-if="!DentalPatients" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-envelope"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Workedon</span>
                </template>
                <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="DentalPatients ? DentalPatients : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                 <template #cell(patientName)="data">
                  {{ data.item.patient.patientName }}
                   <span
                    class="badge rounded-pill bg-success"
                    v-if="data.item.pay_status == 'Cleared'"
                    >Cleared</span
                  >
                   <span
                    class="badge rounded-pill bg-primary"
                    v-else-if="data.item.pay_status == 'insured'"
                    >Insured</span
                  >
                  <span
                    class="badge rounded-pill bg-danger"
                    v-else
                  >
                   Not Cleared</span
                  >
                
                </template>
                <template #cell(temp_field)="data">
                  {{ data.item.temp ? data.item.temp + " &#x2103;" : "--" }}
                </template>
                <template #cell(weight_field)="data">
                  {{ data.item.weight ? data.item.weight + " kg" : "--" }}
                </template>
                <template #cell(actions)="data">
                  <router-link
                    :to="{
                      name: 'PatientsDetails',
                      params: { id: data.item.patient.id, visit: data.item.id, type: 6 },
                    }"
                  >
                    <button class="btn btn-primary btn-sm">Details</button>
                  </router-link>
                </template>
              </b-table>
              <center>
                <h3 v-if="!DentalPatients" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
              </b-tab>
            
            </b-tabs>
          </div>
        </div>
    
      </div>
    </div>
  </Layout>
</template>
